import React, { useState, useEffect } from "react";
import Accordion from "../../../../revampComponents/Atom/Accordion";
import KonfhubContainer from "../../../../revampComponents/Atom/Container"; import EventPageAccordion from "./EventPageAccordion";
import CheckoutPageAccordian from "./CheckoutPageAccordian";
import TaxNIncoiveAccordian from "./TaxNIncoiveAccordian";
import { useFormik } from "formik";
import { UpdateEventDetails } from "../../../../revampCRUD/commonAPIs.crud";
import { getEventDetails } from "../../../../revampCRUD/ticketsNforms.crud";
import FormButtons from "../../../../revampComponents/Molecule/Buttons/FormButtons";
import customToast from "../../../../components/common/basic/Toast";
import Validate from "./Validation";
import { APIStatusCode, diffAndCommon } from "../../../../services/util";
import LoadingSpinner from "../../../../revampComponents/Atom/Loading";
import { EditEventProfileApi, GetEventProfileById } from "../../../../revampCRUD/eventProfile.curd";
import { errorToaster } from "../../../../reusable/common";
import BrandingAndCustomizationNote from "../BrandingAndCustomizationNote";



const Branding = (props) => {
    const { module, profileId, eventInfo, isRestricted } = props;
    const [profileData, setProfileData] = useState([])
    const isEventProfile = module === "event-profile";
       const [eventDetails, setEventDetails] = useState(null);
    const [accordion, setAccordion] = useState("Event Page");
    const [loadPage, setLoadPage] = useState(false);
    const [loading, setLoading] = useState(false)
    const [initialValues, setInitialValues] = useState({
        // remove_kh_branding: false,
        checkout_consent: "",
        navbar_icon: "",
        checkout_footer_icon: "",
        fav_icon: "",
        ticket_footer_icon: "",
        invoice_footer_icon: "",
    })

    const eventId = !isEventProfile ? props?.eventInfo?.event_id : null;
    // const { isRestricted } = props

    function onAccordionClick(label) {
        label == accordion ? setAccordion("Close ALL") : setAccordion(label);
    }

    const validate = async values => {
        let errors = {};
        errors = await Validate(values);
        return errors;
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        // validate: validate,
        onSubmit: async (values) => {
            setLoading(true);
            // const tempVal = {...values}
            const updated_details = diffAndCommon("diff", [values, initialValues], []);
            for (const key in updated_details) {
                if (updated_details.hasOwnProperty(key) && !updated_details[key]) {
                    updated_details[key] = null;
                }
            }
            if(!isEventProfile){
            await UpdateEventDetails(updated_details, eventId)
                .then(({ data }) => {
                    if (data == "OK") {
                        customToast.success("Saved successfully");
                        getEventDetailsFunction(eventId);
                    } else {
                        customToast.error("Something went wrong");
                    }
                })
                .catch(err => {
                    customToast.error("Something went wrong");
                    console.log(err);
                });
                }else{
                    await EditEventProfileApi(profileId, updated_details)
                    .then(({ status, data }) => {   
                    if (status == APIStatusCode?.STATUS_CODE_SUCCESS) {
                        customToast.success("Saved successfully");
                        fetchProfileData(profileId);
                    } else {
                        customToast.error(err?.response?.data?.error || "Something went wrong");
                    }
                })
                .catch(err => {
                    customToast.error(err?.response?.data?.error || "Something went wrong");
                    console.log(err);
                })          
            }
            setLoading(false)
        }
    });

    const getEventDetailsFunction = async (eventId) => {
        setLoadPage(true)
        const Data = await getEventDetails(eventId);
        if (Data.status == 200) {
            setEventDetails(Data || {})
            setInitialValues({
                checkout_consent: Data?.data?.checkout_consent,
                navbar_icon: Data?.data?.navbar_icon,
                checkout_footer_icon: Data?.data?.checkout_footer_icon,
                fav_icon: Data?.data?.fav_icon,
                ticket_footer_icon: Data?.data?.ticket_footer_icon,
                invoice_footer_icon: Data?.data?.invoice_footer_icon
            })
            setLoadPage(false)
        }
    };

    const fetchProfileData = async () => {
        setLoadPage(true);
        try {
            const response = await GetEventProfileById(profileId);
            if (response?.status === APIStatusCode?.STATUS_CODE_SUCCESS) {
                const profile = response?.data?.event_profile;
                setEventDetails(profile);

                setInitialValues({
                    checkout_consent: profile?.checkout_consent || "",
                    navbar_icon: profile?.navbar_icon || "",
                    checkout_footer_icon: profile?.checkout_footer_icon || "",
                    fav_icon: profile?.fav_icon || "",
                    ticket_footer_icon: profile?.ticket_footer_icon || "",
                    invoice_footer_icon: profile?.invoice_footer_icon || "",
                });
            } else {
                throw new Error("Unexpected response from API");
            }
        } catch (err) {
            errorToaster(err?.response?.data?.error || "Failed to load profile data");
        }
        setLoadPage(false);
    };
    useEffect(() => {
        if (isEventProfile) {
            fetchProfileData();
        } else {
            getEventDetailsFunction(eventInfo?.event_id);
        }
    }, []);


    return (
        <>
            <KonfhubContainer>
                {loadPage ? <LoadingSpinner /> :
                    <>
               {isEventProfile &&	<BrandingAndCustomizationNote /> }
                     
                        <div>
                            <Accordion
                                onAccordionClick={onAccordionClick}
                                accordion={accordion}
                                setAccordion={setAccordion}>
                                <div label="Event Page">
                                    <EventPageAccordion eventDetails={eventDetails} formik={formik} isRestricted={isRestricted} />
                                </div>
                            </Accordion>
                        </div>

                        <div>
                            <Accordion
                                onAccordionClick={onAccordionClick}
                                accordion={accordion}
                                setAccordion={setAccordion}>
                                <div label="Checkout Page">
                                    <CheckoutPageAccordian eventDetails={eventDetails} formik={formik} isRestricted={isRestricted} />
                                </div>
                            </Accordion>
                        </div>

                        <div>
                            <Accordion
                                onAccordionClick={onAccordionClick}
                                accordion={accordion}
                                setAccordion={setAccordion}>
                                <div label="Tickets & Invoice">
                                    <TaxNIncoiveAccordian eventDetails={eventDetails} formik={formik} isRestricted={isRestricted} />
                                </div>
                            </Accordion>
                        </div>
                        <div className="mt-5">
                            {!isRestricted && <FormButtons
                                onSave={formik.handleSubmit}
                                onCancel={() => formik.resetForm()}
                                saveBtnContent={"Save"}
                                cancelBtnDisabled={false}
                                isLoading={loading}
                                saveBtnDisabled={loading || !formik.dirty}
                            />}
                        </div>
                    </>}
            </KonfhubContainer>
            <style jsx>
                {`
                .description-text{
                    font-family: Hind;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 22px;
                    letter-spacing: 0em;
                    color: #6D7780;
                }
            `}
            </style>
        </>
    )
}

export default Branding;